<template>
  <div v-if="companyData.length != 0">
    <b-modal ref="busy-message" id="busy-message" hide-footer hide-header>
      <div v-html="messageOfToday"></div>
      <button
        class="btn btn-md btn-secondary mx-0 mt-3 btn-block"
        @click="$bvModal.hide('busy-message')"
      >
        {{ "Okay" | translate }}
      </button>
    </b-modal>
    <closed v-if="onDuty != 'open'" />
    <div v-if="onDuty == 'open'">
      <clientView />
      <orderView />
    </div>
  </div>
</template>

<script>
import orderView from "@/components/orderView.vue";
import clientView from "@/components/clientView.vue";
import closed from "@/components/closed.vue";
import { mapGetters } from "vuex";
import Vue from "vue";
import axios from "axios";

export default {
  name: "app-orderpage",
  components: {
    clientView,
    orderView,
    closed,
  },
  computed: {
    ...mapGetters(["companyData","userData"]),
    onDuty() {
      return this.companyData.onDuty;
    },
    loggedIn() {
      const loggedIn = localStorage.getItem("user");
      if (loggedIn && loggedIn != 0) {
        return true;
      } else {
        return false;
      }
    },
    clientSelected() {
      const clientSelected = localStorage.getItem("client");
      if (clientSelected && clientSelected != 0) {
        return true;
      } else {
        return false;
      }
    },
    inStore() {
      const inStore = localStorage.getItem("company");
      if (inStore && inStore != 0) {
        return true;
      } else {
        return false;
      }
    },
    messageOfToday() {
      return this.companyData.messageOfToday;
    },
  },
  methods: {
    initLang() {
      this.companyData.languages.forEach(function (index) {
        if (index != "") {
          axios
            .get("/locale/" + index + ".json?v=" + Date.now() + "")
            .then((response) => {
              Vue.i18n.add(index, response.data);
            });
        }
      });
      if (this.$route.query.lang) {
        Vue.i18n.set(this.$route.query.lang);
      } else {
        if (!Vue.i18n.locale()) {
          Vue.i18n.set(this.companyData.defaultLanguage);
        }
      }
    },
    showModal() {
      this.$refs["busy-message"].show();
    },
  },
  created() {
    if (this.$route.query.lang) {
      Vue.i18n.set(this.$route.query.lang);
    }
    if (this.inStore) {
      this.companyData.languages.forEach(function (index) {
        if (index != "") {
          axios
            .get("/locale/" + index + ".json?v=" + Date.now() + "")
            .then((response) => {
              Vue.i18n.add(index, response.data);
            });
        }
      });
    } else {
      if (!Vue.i18n.locale()) {
        Vue.i18n.set(this.companyData.defaultLanguage);
      }
    }
  },
  mounted() {
    if (this.$route.params.firstRun == true) {
      this.showModal();
    }
  },
  beforeMount() {
    if (this.loggedIn) {
      var payload = {
        apikey: this.userData.apiKey,
        token: this.userData.token,
      };
      this.$store.dispatch("setStore", payload).then(() => {
        this.initLang();
      });
    } else {
      if (this.$route.query.lang) {
        this.$router.push({
          name: "login",
          query: { lang: this.$route.query.lang },
        });
      } else {
        this.$router.push({
          name: "login",
        });
      }
    }
  },
};
</script>
